module.exports = __webpack_public_path__ + "/content/skins/HDemo/fonts/2F7AA5_0_0.woff2";